import storage from '@/utils/storage';
import { getCurrentUser, getAuthorty, getPermission } from '@/services/common';
import { getAuthRoutes, tranformToCodeAndInfo } from '@/utils/permission/authority';

export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_ROLES = 'SET_ROLES';
export const SET_AUTHORITIES = 'SET_AUTHORITIES';
export const SET_ACCESSED_ROUTES = 'SET_ACCESSED_ROUTES';
export const SET_PLUGIN_INFO = 'SET_PLUGIN_INFO';
const state = {
  accessToken: storage.get('accessToken'),
  // 当前用户信息
  currentUser: {},
  // 当前用户角色信息
  roles: [],
  // 当前用户权限
  authorities: [],
  accessedRoutes: [],
  // 插件状态
  pluginsList: [],
};

const getters = {};

const mutations = {
  [SET_ACCESS_TOKEN](state, { accessToken, expire }) {
    storage.set('accessToken', accessToken, expire);
    state.accessToken = accessToken;
  },
  [SET_CURRENT_USER](state, { currentUser }) {
    state.currentUser = Object.assign(state.currentUser, currentUser);
  },
  [SET_PLUGIN_INFO](state, { info }) {
    state.pluginsList = info;
  },
  [SET_ROLES](state, { roles }) {
    state.roles = roles;
  },
  [SET_AUTHORITIES](state, authorities) {
    state.authorities = authorities;
  },
  [SET_ACCESSED_ROUTES](state, { accessedRoutes }) {
    state.accessedRoutes = accessedRoutes;
  },
};

const actions = {
  setAccessToken({ commit }, { accessToken, expire }) {
    commit(SET_ACCESS_TOKEN, { accessToken, expire });
  },
  setPluginInfo({ commit }, { info }) {
    commit(SET_PLUGIN_INFO, { info });
  },
  setCurrentUser({ commit }, { currentUser }) {
    commit(SET_CURRENT_USER, { currentUser });
  },
  setRoles({ commit }, { roles }) {
    commit(SET_ROLES, { roles });
  },
  setAuthorities({ commit }, authorities) {
    commit(SET_AUTHORITIES, authorities);
  },
  setAccessedRoutes({ commit }, { accessedRoutes }) {
    commit(SET_ACCESSED_ROUTES, { accessedRoutes });
  },
  getAppData(context) {
    return new Promise((resolve, reject) => {
      /*
        为什么这里采用Promise.all
        方便各个系统拓展自己对应接口去获取 用户信息、用户权限.
        如果是一个接口返回，可以直接一个接口获取数据后复制给对应的state即可
      */
      const userInfoPromise = getCurrentUser();
      const getAuthortyPromise = getAuthorty();
      const permission = getPermission();
      Promise.all([userInfoPromise, getAuthortyPromise, permission])
        .then((resArr) => {
          const resUserinFo = resArr[0].result;
          const resAuthory = resArr[1].result || [];
          const userPermission = resArr[2].result;
          // eslint-disable-next-line
          const permissionList = (userPermission && userPermission.operations) || [];
          // 判断用户是否登录。  没登录=》没数据=》直接重定向去sso登陆页。
          if (!resUserinFo) {
            window.location.href = `${process.env.VUE_APP_GRAPH_URL}?redirect_uri=${window.location.href}`;
            return;
          }
          // 保存用户信息
          context.commit(SET_CURRENT_USER, { currentUser: resUserinFo || {} });
          // 保存角色
          context.commit(SET_ROLES, { roles: resUserinFo.roles || [] });

          const { code, info } = tranformToCodeAndInfo(resAuthory);

          permissionList.push(...code);

          // 保存菜单、按钮权限
          context.commit(SET_AUTHORITIES, permissionList);

          // 保存插件信息
          context.commit(SET_PLUGIN_INFO, { info });

          // 根据权限码筛选路由
          const accessedRoutes = getAuthRoutes(context);
          // 保存拥有权限的路由
          context.commit(SET_ACCESSED_ROUTES, { accessedRoutes });
          resolve({ accessedRoutes, ...resUserinFo });
        })
        .catch((error) => {
          console.error(error);
          reject(error);
        });
    });
  },
  async updatePluginList({ commit }) {
    const { result: resAuthory } = await getAuthorty();
    const { info } = tranformToCodeAndInfo(resAuthory);
    // 保存插件信息
    commit(SET_PLUGIN_INFO, { info });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
